/**
 * ComposeTargetLocation Component
 * Target location selector displayed at the top of compose dialog
 * Uses LocationPicker as the source of truth for locations
 */

import { SPACING } from '@/design-system';
import { LComponents } from '@/components/i18n';
import { Label } from '@/components/ui/label';
import { LocationPicker } from '@/components/shared/LocationPicker';
import type { ComposeFormData } from './types';

interface ComposeTargetLocationProps {
  formData: ComposeFormData;
  onFormChange: (updates: Partial<ComposeFormData>) => void;
}

export function ComposeTargetLocation({ formData, onFormChange }: ComposeTargetLocationProps) {
  // Normalize: empty string should be null for LocationPicker
  const locationValue = formData.location && formData.location.trim() ? formData.location : null;

  return (
    <div className={SPACING.stackSm}>
      <Label className="text-sm">
        <LComponents id="compose_message.labels.target_location" defaultValue='Target Location' />
      </Label>
      <LocationPicker
        value={locationValue}
        onSelect={(locationId) => onFormChange({ location: locationId || '' })}
        showInternational={true}
        variant="outline"
        size="default"
        align="start"
        showFlag={true}
        showName={true}
        triggerClassName="w-full justify-between h-10"
      />
    </div>
  );
}
